(ns manatee.ui.styles
  (:require [garden.core :as garden]
            [manatee.admin.styles :as admin-styles]
            [manatee.admin.task-config.styles :as task-styles]
            [manatee.annotation.styles :as annotation-styles]
            [manatee.auth.styles :as auth-styles]
            [manatee.dashboard.styles :as dashboard-styles]
            [manatee.header.styles :as header-styles]
            [manatee.qa.styles :as qa-styles]))

(defn base-css
  []
  [(task-styles/main)
   (admin-styles/main)
   (annotation-styles/main)
   (auth-styles/main)
   (dashboard-styles/main)
   (header-styles/main)
   (qa-styles/main)
   [:div.panel.allow-overflow
    {:overflow :visible}]
   [:.panel.primary {:border [["0.1rem" :solid "#dcd"]]
                     :border-top :none}]
   [:.nav__item.horizontal {:border-bottom [["0.3rem" :solid "#989"]]
                            :padding-inline "2rem"
                            :background "#f6f6f6"}]
   [:.nav__item.horizontal.selected {:border [["0.1rem" :solid "#dcd"]]
                                     :border-bottom :none
                                     :color "black"
                                     :background "white"}]])

(defn compile-styles
  [garden-options]
  (garden/css garden-options (base-css)))

#?(:cljs
   (defn get-or-make
     [parent id]
     (or (.getElementById js/document id)
         (let [node (.createElement js/document "style")]
           (.setAttribute node "type" "text/css")
           (.setAttribute node "id" id)
           (.appendChild parent node)
           node))))

#?(:cljs
   (defn dynamic-style
     [key style]
     (let [root (get-or-make (.-head js/document) "dynamic-styles")
           node (get-or-make root (name key))
           css-string (if (string? style)
                        style
                        (garden/css style))]
       (prn "Installing dynamic style" css-string)
       (set! (.-innerHTML node) css-string))))
